module.exports = __webpack_public_path__ + "img/testBoxIcon.e49be773.png";